import { render, staticRenderFns } from "./formV2.vue?vue&type=template&id=4dda7ca6&"
import script from "./formV2.vue?vue&type=script&lang=js&"
export * from "./formV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports